import {
  PersonAdd as AddUserIcon,
  Login as LoginIcon,
  Settings,
  GridView as UserGridIcon,
} from "@mui/icons-material";
import SpeedIcon from '@mui/icons-material/Speed';
import SessionsIcon from "./Sessions";
import UserManagementIcon from "./UserManagement";
import UserProfileIcon from "./UserProfile";
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

//new icons
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import { Money } from "@mui/icons-material";
//import logo from "../../assets/user.png";

import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import BalanceIcon from "@mui/icons-material/Balance";
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import CalculateIcon from "@mui/icons-material/Calculate";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import GroupsIcon from "@mui/icons-material/Groups";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import PaidIcon from "@mui/icons-material/Paid";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SavingsIcon from "@mui/icons-material/Savings";
import SmsIcon from "@mui/icons-material/Sms";
//import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
//new icons

//Dashboard Sidebar Icons
import HomeIcon from '@mui/icons-material/Home';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

// eslint-disable-next-line import/no-anonymous-default-export
export default {

  HomeIcon,
  MonetizationOnIcon,
  RequestQuoteIcon,
  
  LoginIcon,
  AddUserIcon,
  SessionsIcon,
  UserGridIcon,
  SpeedIcon,
  UserProfileIcon,
  UserManagementIcon,
  PersonOutlinedIcon,
  CalendarTodayOutlinedIcon,
  HelpOutlineOutlinedIcon,
  BarChartOutlinedIcon,
  PieChartOutlineOutlinedIcon,
  TimelineOutlinedIcon,
  MenuOutlinedIcon,
  MapOutlinedIcon,
  EmojiEventsIcon,
  Money,
  //logo,
  //SpaceDashboardIcon,
  ConfirmationNumberIcon,
  GroupsIcon,
  PaidIcon,
  SavingsIcon,
  BalanceIcon,
  CalculateIcon,
  SmsIcon,
  PhoneAndroidIcon,
  LocalShippingIcon,
  AccountBalanceIcon,
  SupportAgentIcon,
  AccountBalanceWalletIcon,
  DriveFolderUploadIcon,
  StackedLineChartIcon,
  AdminPanelSettingsIcon,
  KeyboardArrowRightIcon,
  SupervisorAccountIcon,
  Settings
};
